import { API_URL } from './config'

export async function fetchForm (formId) {
  try {
    const response = await fetch(`${API_URL}/forms/${formId}`)
    const data = await response.json()
    return data
  } catch (err) {
    console.error(err)
  }
  return null
}
